import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import config from '../config';

function MapCard(props) {
    return (
        <Card>
            <Card.Body>
                <div className="gmaps" style={{ position: 'relative', overflow: 'hidden', height: props.height }}>
                    <Map
                        google={props.google}
                        zoom={18}
                        initialCenter={{ lat: props.lat || 21.569874, lng: props.lng || 71.5893798 }}
                        style={{ width: '100%', height: '100%', position: 'relative' }}
                        zoomControlOptions={{
                            position: props.google.maps.ControlPosition.LEFT_TOP,
                        }}
                    >
                        <Marker
                            title={'This is sweet home.'}
                            name={'Home sweet home!'}
                            position={{ lat: props.lat || 21.569874, lng: props.lng || 71.5893798 }}
                        ></Marker>
                    </Map>
                </div>
            </Card.Body>
        </Card>
    );
}

MapCard.propTypes = {
    lat: PropTypes.number,
    lng: PropTypes.number,
};

export default GoogleApiWrapper({
    apiKey: config.google.maps.api_key,
})(React.memo(MapCard));
